import { FETCH_AUTOCOMPLETE } from '../constants/actionTypes';

const autocomplete = (autocomplete = [], action) => {
  switch (action.type) {
    case FETCH_AUTOCOMPLETE:
      return action.payload;
    
    default:
      return autocomplete;
  }
};

export default autocomplete;
